export const toggleAppbarWhiteFont = (isWhite) => ({
    type: 'APPBAR_FONT_COLOR',
    data: { isWhite: isWhite }
})

// module.exports = {
//     toggleAppbarWhiteFont: toggleAppbarWhiteFont
// }